/* eslint-disable no-console */
/* eslint-disable max-len */
import { useSelector } from 'react-redux';
import { getRelationsData } from '../../../../../../actions/feeds_actions_new';
import { catchErr } from '../../../../../../../libs/HelperContent';
import useFeedApproval from '../../CustomHooks/useFeedApproval';

export const useGetFeedApi = () =>
{
	const userData = useSelector((state:any) => state?.mysession?.session);
	const { isFeedsAdmin } = useFeedApproval();
	const getFeedRelations = async (relationsRef, setLoading) =>
	{
		try
		{
			setLoading(true);
			const query = {
				type      : 'feed',
				selection : true,
				skip      : 0,
				limit     : 20,
				uid       : userData?.userId,
				comid     : userData?.companyId,
				empRole   : userData?.empRole,
				role      : userData?.role

			};
			const res = await getRelationsData(query);

			if (res?.status)
			{
				if (isFeedsAdmin)
				{
					relationsRef.current = (res?.data);
				}
				else
				{
					relationsRef.current = res?.data?.filter((reltn) => reltn?.relation === 'company internal employees');
				}

				// if (createFeed?.relations && createFeed?.relations?.length > 0)
				// {
				// 	const filterData = res?.data?.filter((reltn) => createFeed?.relations?.some((dataD) => dataD?.relationId === reltn?.relationId));

				// 	setUpdateReltns(filterData);
				// }

				return res?.data;
			}
			else
			{
				relationsRef.current = [];
			}
		}
		catch (err)
		{
			console.log(err);
			catchErr(err);
		}
		finally
		{
			setLoading(false);
		}
	};

	return getFeedRelations;
};
